import { render, staticRenderFns } from "./DetailMetricNonEdit.vue?vue&type=template&id=b9034e56"
import script from "./DetailMetricNonEdit.vue?vue&type=script&lang=js"
export * from "./DetailMetricNonEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports